var gravityForms = new function () {
    this.doChangeStep = function (event, element) {
        var direction = ($(element).hasClass('form__step-prev') ? 'previous' : 'next'),
            $form = $(element).closest('.gform_steps');
        $form.find('.gform_page:visible').find('.gform_' + direction + '_button').trigger('click');
    };
    this.doFileUpload = function(event, element) {
        var fileName = element.files[0].name;
        fileName = '<div class="ginput_container_fileupload--filename">' + fileName + '</div>';
        $(element).closest('.ginput_container_fileupload').remove('.ginput_container_fileupload--filename').prepend(fileName);
    };
    this.setLabels = function () {
        var $label;
        $('.form-item--floating-label').each(function () {
            $label = $(this).find('.form-item__label');
            if ($label.width() > 0) {
                if ($label.width() > $(this).width()) {
                    $label.remove();
                    $(this).prepend($label);
                    $(this).removeClass('form-item--floating-label');
                }
            }
        });
    };
};

gravityForms.setLabels();
$(window).on('resize', function(){
    gravityForms.setLabels();
});
$(document).on('gform_post_render', function(event, form_id, current_page){
    gravityForms.setLabels();
});
$(document).on('keydown', '.gform_body input, .gform_body select', function(event) {
    var keyCode = (event.keyCode ? event.keyCode : event.which);
    if (keyCode == 13) {
        event.preventDefault();
        if (!$(this).hasClass('loqate-field-postcode')) {
            var $body = $(this).closest('.gform_body');
            if ($body.find('.gform_next_button').length) {
                $body.find('.gform_next_button').trigger('click');
            } else {
                $(this).closest('form').find('.gform_footer .button').trigger('click');
            }
        }
    }
});
$(document).on('click', '.form-tooltip', function(e) { e.preventDefault(); });